<template>
  <a-form-item :label="openLabel"
    ><a-switch
      v-model:checked="channel.enabled"
      checked-children="已开放"
      un-checked-children="已关闭"
  /></a-form-item>
  <a-form-item label="收银台展示名称"
    ><a-input v-model:value="channel.displayName" :maxlength="30"
  /></a-form-item>
  <a-form-item v-if="paymentTypeOptions" label="优优支付方式" extra="请只选择商户后台已开通的方式。"
    ><a-select v-model:value="channel.providerPaymentType" :options="paymentTypeOptions"
  /></a-form-item>
  <div class="form-row">
    <a-form-item label="最低支付金额（分）"
      ><a-input-number
        v-model:value="channel.minAmountMinor"
        :min="1"
        :max="10000000"
        :precision="0" /></a-form-item
    ><a-form-item label="最高支付金额（分）"
      ><a-input-number
        v-model:value="channel.maxAmountMinor"
        :min="1"
        :max="100000000"
        :precision="0"
    /></a-form-item>
  </div>
  <a-form-item label="展示排序"
    ><a-input-number v-model:value="channel.sort" :min="0" :max="99" :precision="0"
  /></a-form-item>
  <a-form-item label="可售商品类型"
    ><a-select v-model:value="channel.productKinds" mode="multiple" :options="productKindOptions"
  /></a-form-item>
  <a-form-item label="维护提示"
    ><a-textarea
      v-model:value="channel.maintenanceMessage"
      :maxlength="120"
      :rows="2"
      show-count
      placeholder="渠道关闭时显示给用户的说明"
  /></a-form-item>
</template>

<script setup lang="ts">
type Channel = {
  enabled: boolean;
  displayName: string;
  minAmountMinor: number;
  maxAmountMinor: number;
  sort: number;
  maintenanceMessage: string;
  productKinds: string[];
  providerPaymentType?: string;
};
defineProps<{
  channel: Channel;
  productKindOptions: Array<{ label: string; options: Array<{ value: string; label: string }> }>;
  openLabel: string;
  paymentTypeOptions?: Array<{ value: string; label: string }>;
}>();
</script>

<style scoped>
.form-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}
.form-row :deep(.ant-input-number) {
  width: 100%;
}
@media (max-width: 760px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}
</style>
